export default "__VITE_ASSET__CDIL0ea4__"